import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1024.000000 580.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,580.000000) scale(0.100000,-0.100000)">
        <path d="M1180 3898 c-33 -17 -51 -35 -67 -68 l-23 -44 0 -733 c0 -792 -1
-771 53 -822 35 -31 111 -40 155 -17 70 36 66 7 72 647 l5 576 125 -119 c344
-328 370 -347 458 -348 42 0 47 4 203 153 212 202 317 297 329 297 7 0 10
-197 10 -564 l0 -563 23 -34 c57 -85 177 -85 234 0 l23 34 0 760 0 760 -22 35
c-22 35 -84 71 -126 72 -51 0 -102 -38 -300 -227 -114 -109 -249 -236 -300
-282 l-93 -84 -37 35 c-516 482 -565 526 -606 543 -47 20 -64 19 -116 -7z"/>
<path d="M3240 3353 l0 -458 87 0 88 0 5 280 5 280 92 -182 92 -181 68 -8 c52
-5 68 -4 72 7 9 29 160 325 175 344 14 18 15 -4 16 -257 l0 -277 90 -3 90 -3
0 458 0 457 -98 0 -97 0 -119 -232 c-66 -128 -120 -234 -121 -236 -2 -2 -42
75 -90 170 -48 95 -103 201 -122 236 l-35 62 -99 0 -99 0 0 -457z"/>
<path d="M6020 3356 l0 -455 95 -3 95 -3 0 458 0 457 -95 0 -95 0 0 -454z"/>
<path d="M4533 3763 c-6 -21 -76 -216 -155 -433 -80 -217 -148 -404 -152 -415
-6 -19 -2 -20 94 -17 l99 3 28 87 28 87 165 0 165 0 30 -87 30 -88 102 0 103
0 -19 48 c-10 26 -39 106 -65 177 -25 72 -90 252 -145 400 l-98 270 -99 3
-100 3 -11 -38z m162 -339 c28 -86 51 -163 53 -170 3 -11 -18 -14 -108 -14
-91 0 -111 3 -108 14 9 40 104 326 108 326 3 0 28 -70 55 -156z"/>
<path d="M5118 3768 c10 -18 74 -120 141 -226 l122 -194 -52 -81 c-29 -45 -94
-146 -146 -224 l-92 -143 112 0 112 1 50 82 c28 45 68 114 91 155 l41 73 12
-28 c6 -15 47 -84 90 -153 l78 -125 112 -5 c72 -3 110 -1 107 5 -2 6 -65 104
-140 218 -75 114 -139 213 -142 220 -2 7 58 112 135 235 l139 222 -106 0 -107
-1 -50 -82 c-27 -45 -68 -117 -91 -160 l-41 -78 -18 43 c-10 24 -50 96 -89
161 l-70 117 -109 0 -109 0 20 -32z"/>
<path d="M6390 3350 l0 -450 204 0 c172 0 214 3 265 19 171 53 257 159 282
348 30 222 -42 398 -194 475 -91 46 -168 58 -374 58 l-183 0 0 -450z m432 248
c89 -41 128 -118 128 -253 0 -133 -37 -207 -124 -250 -58 -28 -180 -42 -223
-24 l-23 8 0 277 0 277 93 -5 c72 -4 107 -11 149 -30z"/>
<path d="M7490 3797 c0 -5 -299 -839 -315 -879 -7 -16 2 -18 91 -18 l99 0 29
90 29 90 166 -2 165 -3 32 -85 32 -85 96 -3 c73 -2 96 0 96 10 0 7 -16 56 -36
108 -19 52 -89 241 -154 420 -65 179 -121 333 -125 343 -6 15 -21 17 -106 17
-54 0 -99 -2 -99 -3z m155 -375 c27 -86 51 -163 53 -169 3 -10 -23 -13 -108
-13 -102 0 -112 2 -107 18 22 80 102 322 107 322 3 0 27 -71 55 -158z"/>
<path d="M7950 3715 l0 -85 130 0 130 0 0 -364 0 -365 95 -3 95 -3 0 368 0
367 125 0 125 0 0 85 0 85 -350 0 -350 0 0 -85z"/>
<path d="M8899 3773 c-6 -15 -76 -208 -155 -428 -79 -220 -149 -410 -154 -422
-10 -23 -9 -23 89 -23 l98 0 29 88 29 87 166 3 166 2 23 -62 c47 -133 29 -118
142 -118 91 0 100 2 93 18 -4 9 -59 159 -122 332 -63 173 -133 367 -157 430
l-42 115 -97 3 -97 3 -11 -28z m165 -367 l54 -166 -115 0 c-88 0 -114 3 -111
13 4 10 88 266 104 316 2 8 7 12 10 9 2 -3 29 -80 58 -172z"/>
<path d="M1539 3007 c-46 -31 -68 -91 -48 -132 8 -16 30 -40 49 -53 28 -18 42
-22 73 -16 38 6 42 4 97 -51 l58 -57 -15 -45 c-11 -33 -13 -56 -7 -86 9 -40 8
-42 -35 -83 -41 -38 -47 -41 -78 -32 -74 20 -146 -53 -121 -124 36 -101 183
-81 193 26 3 30 14 49 44 80 l40 40 23 -21 c13 -12 36 -26 51 -32 33 -13 113
-13 142 -1 16 6 29 -1 61 -32 38 -37 41 -43 37 -80 -7 -51 11 -84 53 -98 61
-21 125 36 109 97 -8 35 -41 63 -74 63 -21 0 -39 12 -70 46 -23 26 -40 50 -39
53 2 3 12 23 23 44 17 33 23 37 57 37 34 0 40 -4 49 -29 11 -30 45 -51 84 -51
37 0 78 41 78 78 0 75 -71 113 -138 73 -20 -12 -51 -21 -68 -21 -29 0 -34 4
-48 44 l-16 45 54 53 c47 47 59 53 97 54 74 2 118 42 118 109 0 104 -130 152
-197 73 -24 -28 -27 -39 -23 -85 4 -51 4 -53 -42 -98 l-46 -46 -45 20 c-57 26
-119 26 -170 0 l-41 -20 -57 55 c-40 38 -55 59 -50 68 27 41 -3 117 -55 142
-46 22 -67 20 -107 -7z"/>
<path d="M4576 2580 c-39 -12 -66 -38 -87 -85 -46 -99 -1 -197 102 -225 45
-12 104 0 139 28 l22 17 -21 19 c-18 17 -21 17 -43 2 -34 -24 -92 -20 -125 8
-25 21 -28 31 -28 81 0 50 3 60 28 81 33 28 91 32 124 9 18 -13 22 -12 38 5
23 25 8 45 -44 60 -42 12 -65 12 -105 0z"/>
<path d="M4900 2572 c-53 -26 -80 -74 -80 -141 0 -78 23 -120 82 -150 44 -21
52 -22 98 -11 116 28 159 173 78 265 -46 53 -117 68 -178 37z m99 -43 c38 -13
61 -54 61 -108 0 -88 -91 -133 -157 -77 -24 21 -27 31 -27 79 0 45 4 61 23 81
13 14 33 27 45 29 11 2 21 5 22 6 1 0 15 -4 33 -10z"/>
<path d="M7060 2568 c-59 -31 -84 -74 -81 -145 3 -90 37 -135 118 -154 27 -6
53 -4 90 6 61 18 71 29 48 55 -16 18 -20 18 -46 5 -92 -48 -182 31 -149 130
20 59 77 81 146 55 23 -9 31 -8 46 8 19 18 19 19 -7 36 -44 29 -113 31 -165 4z"/>
<path d="M8235 2576 c-145 -67 -116 -281 42 -311 54 -10 122 28 151 85 12 24
22 58 22 75 0 40 -38 114 -71 138 -34 25 -105 31 -144 13z m111 -61 c50 -32
55 -125 9 -171 -34 -33 -93 -33 -125 1 -34 36 -39 111 -10 148 37 47 75 54
126 22z"/>
<path d="M8973 2574 c-59 -29 -65 -110 -12 -148 13 -9 44 -23 70 -31 50 -17
67 -39 48 -61 -14 -17 -79 -18 -114 -2 -21 10 -29 9 -43 -6 -16 -16 -16 -18 3
-32 30 -23 92 -36 132 -28 52 10 83 44 83 92 0 48 -22 70 -98 97 -48 18 -57
25 -57 45 0 22 5 25 42 28 23 2 51 -1 61 -7 14 -7 21 -5 30 10 17 26 9 36 -36
49 -50 14 -71 12 -109 -6z"/>
<path d="M3240 2555 c0 -23 3 -25 50 -25 l50 0 0 -130 0 -130 25 0 25 0 0 130
0 130 50 0 c47 0 50 2 50 25 l0 25 -125 0 -125 0 0 -25z"/>
<path d="M3590 2425 l0 -155 95 0 c95 0 95 0 95 25 0 24 -2 25 -70 25 l-70 0
0 45 0 45 65 0 c58 0 65 2 65 20 0 18 -7 20 -65 20 l-65 0 0 40 0 40 70 0 c68
0 70 1 70 25 0 25 0 25 -95 25 l-95 0 0 -155z"/>
<path d="M3890 2425 l0 -155 95 0 c95 0 95 0 95 25 0 24 -2 25 -65 25 l-65 0
0 130 0 130 -30 0 -30 0 0 -155z"/>
<path d="M4185 2568 c-2 -7 -3 -76 -2 -153 l2 -140 95 0 c91 0 95 1 98 23 3
21 0 22 -67 22 l-71 0 0 40 0 40 65 0 c63 0 65 1 65 25 0 24 -2 25 -70 25
l-70 0 0 40 0 39 73 3 c66 3 72 5 75 26 3 21 1 22 -93 22 -68 0 -97 -4 -100
-12z"/>
<path d="M5232 2428 c3 -152 3 -153 26 -156 l24 -4 -4 111 c-1 61 -1 111 2
111 4 0 24 -36 45 -80 21 -44 44 -80 51 -80 6 0 30 35 53 78 l40 77 3 -75 c1
-41 2 -90 1 -108 0 -30 2 -33 26 -30 14 2 25 6 24 11 -2 4 -3 72 -3 152 l0
145 -30 0 c-27 0 -33 -7 -71 -82 l-41 -81 -41 81 c-40 77 -44 82 -75 82 l-33
0 3 -152z"/>
<path d="M5660 2426 l0 -156 25 0 c24 0 24 1 27 103 l3 102 38 -72 c20 -40 43
-73 50 -73 6 0 30 35 52 78 l40 77 7 -55 c3 -30 6 -79 7 -107 1 -46 4 -53 21
-53 19 0 20 7 20 155 l0 155 -32 0 c-31 0 -35 -5 -73 -80 l-39 -80 -19 37
c-55 106 -64 118 -96 121 l-31 3 0 -155z"/>
<path d="M6082 2451 c3 -110 6 -132 22 -150 29 -32 89 -45 139 -29 63 20 77
55 77 196 l0 112 -30 0 -30 0 0 -114 c0 -129 -7 -146 -65 -146 -54 0 -65 25
-65 152 l0 108 -26 0 -26 0 4 -129z"/>
<path d="M6436 2428 l1 -153 27 -3 27 -3 -3 105 c-2 58 -1 106 2 106 3 -1 38
-48 78 -105 65 -93 77 -105 103 -105 l29 0 0 155 0 155 -30 0 -30 0 0 -107 0
-106 -73 104 c-61 88 -77 104 -102 107 l-30 3 1 -153z"/>
<path d="M6810 2425 l0 -155 30 0 30 0 0 155 0 155 -30 0 -30 0 0 -155z"/>
<path d="M7386 2432 c-31 -81 -56 -151 -56 -155 0 -4 11 -7 26 -7 19 0 28 8
40 35 14 35 15 35 77 35 62 0 63 0 72 -32 8 -28 15 -34 44 -36 25 -3 32 0 28
10 -40 99 -97 249 -102 271 -6 22 -13 27 -40 27 l-32 0 -57 -148z m107 25 c9
-30 17 -57 17 -60 0 -4 -18 -7 -41 -7 -35 0 -40 3 -34 18 3 9 11 36 18 60 6
23 14 42 17 42 3 0 13 -24 23 -53z"/>
<path d="M7650 2555 c0 -23 4 -25 45 -25 l45 0 2 -112 c0 -62 1 -121 0 -130
-1 -13 6 -18 23 -18 l25 0 0 130 0 130 55 0 c52 0 55 1 55 25 l0 25 -125 0
-125 0 0 -25z"/>
<path d="M7990 2425 c0 -148 1 -155 20 -155 19 0 20 7 20 155 0 148 -1 155
-20 155 -19 0 -20 -7 -20 -155z"/>
<path d="M8550 2425 l0 -155 30 0 29 0 3 101 3 101 70 -101 c60 -86 74 -101
98 -101 l27 0 0 155 0 155 -25 0 c-24 0 -24 -1 -27 -106 l-3 -106 -74 106
c-65 92 -79 106 -103 106 l-28 0 0 -155z"/>
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
